// Generated by Ktorfit
@file:Suppress("warnings")

package kpt.core.network.frankfurter.api

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.http.HttpMethod
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kpt.core.base.network.`annotation`.ApiBinding
import kpt.core.network.frankfurter.dto.ExchangeRatesDto
import kpt.core.network.frankfurter.dto.RateHistoryDto

@OptIn(InternalKtorfitApi::class)
@ApiBinding(accessPoint = "frankfurter")
public class _FrankfurterApiImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : FrankfurterApi {
  override suspend fun getLatestRates(from: String): ExchangeRatesDto {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "v1/latest")
        from?.let{ parameter("from", "$it") }
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<ExchangeRatesDto>(),)!! 
  }

  override suspend fun getHistoricalRates(
    startDate: String,
    endDate: String,
    from: String,
    to: String,
  ): RateHistoryDto {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "v1/${"$startDate".encodeURLPath()}..${"$endDate".encodeURLPath()}")
        from?.let{ parameter("from", "$it") }
        to?.let{ parameter("to", "$it") }
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<RateHistoryDto>(),)!! 
  }
}

public class _FrankfurterApiProvider : ClassProvider<FrankfurterApi> {
  override fun create(_ktorfit: Ktorfit): FrankfurterApi = _FrankfurterApiImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createFrankfurterApi(): FrankfurterApi = _FrankfurterApiImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
